// extracted by mini-css-extract-plugin
export default {"school_info":"school-info_school_info__kvm8A","location":"school-info_location__GTGht","miles":"school-info_miles__F41-8"};